import { render } from "./DataList.vue?vue&type=template&id=59a4b662&scoped=true"
import script from "./DataList.vue?vue&type=script&lang=js"
export * from "./DataList.vue?vue&type=script&lang=js"

import "./DataList.vue?vue&type=style&index=0&id=59a4b662&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-59a4b662"

export default script